@if (workspaceKind() === 'team') {
  <app-multi-select-button
    class="assign-menu-trigger"
    label="Assign to"
    searchPlaceholder="Search team"
    [items]="otherItems()"
    [pinnedItems]="selfItem()"
    [selectedIds]="assigneeIds()"
    [selectionReadonly]="readonlySelection()"
    [selectionPending]="pending()"
    [disabled]="triggerDisabled()"
    [searchable]="canAssign()"
    [searchMode]="searchMode()"
    [hasMore]="hasMore()"
    [loadingMore]="loadingMore()"
    [topText]="topText()"
    [bottomText]="bottomText()"
    [action]="action()"
    [loading]="loading()"
    [triggerTemplate]="assignTrigger"
    [errorText]="errorText()"
    (selectedIdsChange)="assigneeIdsChange.emit($event)"
    (actionClick)="onAction($event)"
    (retry)="retry.emit()"
    (searchChange)="searchChange.emit($event)"
    (loadMore)="loadMore.emit()"
  />
  <ng-template appSelectTrigger #assignTrigger let-opened="opened">
    @if (status() === 'resolved') {
      <span class="assign-trigger-resolved"><app-icon name="sapphire-check" size="s" /></span>
    } @else if (triggerAvatars().length) {
      <span class="assign-trigger-avatars">
        @for (avatar of triggerAvatars(); track $index) {
          <span
            class="assign-trigger-avatar"
            [style.background-color]="avatar.backgroundColor"
            [style.color]="avatar.textColor"
          >
            @if (avatar.imageUrl) {
              <img [src]="avatar.imageUrl" alt="" />
            } @else {
              {{ avatar.initials }}
            }
          </span>
        }
      </span>
    } @else {
      <app-icon name="sapphire-user-plus" size="m" />
    }
    {{ triggerLabel() }}
    <app-icon [name]="opened ? 'sapphire-chevron-up' : 'sapphire-chevron-down'" size="s" />
  </ng-template>
}
